import { create } from 'zustand'
import type { IUser } from '@features/users'
import type { MFASession } from '../features/auth/services/mfaService'

export type AuthStatus =
  | 'idle'
  | 'authenticating'
  | 'mfa-pending'
  | 'authenticated'
  | 'unauthenticated'

type AuthState = {
  user: IUser | null
  status: AuthStatus
  mfaSession: MFASession | null
  isLoading: boolean
}

type AuthActions = {
  setUser: (user: IUser | null) => void
  requireMFA: (session: MFASession) => void
  clearMFA: () => void
  reset: () => void
  setLoading: (loading: boolean) => void
}

const initialState: AuthState = {
  user: null,
  status: 'unauthenticated',
  mfaSession: null,
  isLoading: true,
}

export const useAuthStore = create<AuthState & AuthActions>()((set) => ({
  ...initialState,
  setUser: (user) =>
    set({
      user,
      status: user ? 'authenticated' : 'unauthenticated',
      mfaSession: null,
    }),
  requireMFA: (session) => set({ status: 'mfa-pending', mfaSession: session }),
  clearMFA: () => set({ mfaSession: null }),
  // isLoading:false no reset: só o PRIMEIRO mount fica "verificando" (isLoading
  // inicial = true). reset() é chamado no logout/sessão-revogada — aí já se sabe
  // que está unauthenticated, então não pode voltar pro estado de loading (senão
  // o PreventAuthAccess trava em "Verificando autenticação..." pós-logout).
  reset: () => set({ ...initialState, isLoading: false }),
  setLoading: (loading) => set({ isLoading: loading }),
}))
